import { render, staticRenderFns } from "./DragNode.vue?vue&type=template&id=2783748a&"
import script from "./DragNode.vue?vue&type=script&lang=js&"
export * from "./DragNode.vue?vue&type=script&lang=js&"
import style0 from "./DragNode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports